import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: 'ファイル',

  // model
  fileModel: [],
  serviceModel: [],
  tenantModel: [],

  // 検索
  filters: {
    searchFileName: null,
    searchService: '',
    searchTenant: '',
  },
  
  // form
  targetId: Constants.RegisterHash,
  values: {}
}

const getters = {
  get: state => state,

  // form mode
  isRegister: state => state.targetId === Constants.RegisterHash,
  isModify: state => state.targetId !== Constants.RegisterHash,
  
  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.values[key]
      switch (key) {
        default:
          return value
      }
    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  }
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {fileParams, serviceParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        [
          'file',
          'service',
          'tenant'
        ],
        [
          'v1FileListGet',
          'v1ServiceListGet',
          'v1TenantListGet'
        ],
        [
          fileParams,
          serviceParams,
          {}
        ])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setFileModel', res[0].data.files)
            commit('setServiceModel', res[1].data.serviceInfo)
            commit('setTenantModel', res[2].data.tenants)
            console.log('fileModel', state.fileModel)
            console.log('serviceModel', state.serviceModel)
            console.log('tenantModel', state.tenantModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          reject(null)
        })
    })
  },

  /**
   * ファイル一覧を読出し
   */
  loadFileList ({commit}, {fileParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['file',],
        ['v1FileListGet',],
        [fileParams,])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setFileModel', res[0].data.files)
            console.log('fileModel', state.fileModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          reject(null)
        })
    })
  },

  /**
   * フォームの初期化
   */
  initRegister ({commit}) {
    commit('setTargetId', Constants.RegisterHash)
    commit('initRegister')
  },
  initModify ({commit}, {data}) {
    commit('setTargetId', data.fileUuid)
    commit('initModify', data)
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  // model
  setFileModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    
    // 絞り込みでサービスが選択されている場合、全てのサービスのデータは削除する
    const filteredData = state.filters.searchService
      ? data.filter(item => item.services.length > 0)
      : data;
    Vue.set(state, 'fileModel', filteredData)
  },
  setServiceModel (state, data) {
    data.sort(Utility.sortByKey('ServiceId', true))
    Vue.set(state, 'serviceModel', data)
  },
  setTenantModel (state, data) {
    Vue.set(state, 'tenantModel', data)
  },

  setInputFilter (state, {key, value}) {
    Vue.set(state.filters, key, value)
  },

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },

  // form mode
  initRegister (state) {
    Vue.set(state.values, 'inpFile', null)
    Vue.set(state.values, 'inpService', [])
  },
  initModify (state, data) {
    Vue.set(state, 'values', data)
    Vue.set(state.values, 'inpFile', null)
    Vue.set(state.values, 'inpService', data.services.map(item => item.serviceUuid))
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
